import { Clock, MapPin, Scissors } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_barber-membership-1/artifacts/lnz6qr8g_Screenshot_20260112_182038_Drive.jpg";

export default function HeroSection({ onStartQuiz, onViewPlans }) {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/18173343/pexels-photo-18173343.jpeg"
          alt="Premium barbershop"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
        <div className="absolute inset-0 bg-[#0A0A0B]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 py-32 max-w-4xl">
        {/* Overline */}
        <div className="animate-fade-in-up opacity-0 flex items-center gap-3 mb-8">
          <div className="h-px w-12 bg-[#C5A059]" />
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
            San Francisco Bay Area
          </span>
        </div>

        {/* Headline */}
        <h1
          data-testid="hero-headline"
          className="animate-fade-in-up opacity-0 delay-100 font-heading text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-medium text-[#F3F4F6] leading-[1.05] mb-6"
        >
          Your barber.
          <br />
          <span className="text-[#C5A059]">Your schedule.</span>
          <br />
          Your door.
        </h1>

        {/* Subheadline */}
        <p
          data-testid="hero-subheadline"
          className="animate-fade-in-up opacity-0 delay-200 text-base md:text-lg text-[#A1A1AA] leading-relaxed font-light max-w-xl mb-10"
        >
          LUXGROOM brings precision grooming to busy professionals and athletes
          across the Bay Area. No commute. No waiting. Just elite cuts at your
          doorstep.
        </p>

        {/* Feature pills */}
        <div className="animate-fade-in-up opacity-0 delay-300 flex flex-wrap gap-4 mb-12">
          {[
            { icon: Scissors, text: "Expert barbers" },
            { icon: Clock, text: "We come to you" },
            { icon: MapPin, text: "SF Bay Area" },
          ].map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-2 px-4 py-2 rounded-sm bg-white/5 border border-white/10 text-sm text-[#A1A1AA]"
            >
              <item.icon className="w-4 h-4 text-[#C5A059]" />
              {item.text}
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="animate-fade-in-up opacity-0 delay-400 flex flex-wrap gap-4">
          <button
            data-testid="hero-cta-quiz"
            onClick={onStartQuiz}
            className="bg-[#C5A059] text-black hover:bg-[#D4AF37] font-medium transition-all duration-300 rounded-sm px-8 py-4 text-sm uppercase tracking-wider"
          >
            Find Your Plan
          </button>
          <button
            data-testid="hero-cta-plans"
            onClick={onViewPlans}
            className="bg-transparent border border-white/20 text-white hover:border-[#C5A059] hover:bg-white/5 transition-all duration-300 rounded-sm px-8 py-4 text-sm uppercase tracking-wider"
          >
            View Memberships
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-5 h-8 border-2 border-white/20 rounded-full flex justify-center pt-1.5">
          <div className="w-1 h-2 bg-[#C5A059] rounded-full" />
        </div>
      </div>
    </section>
  );
}
